import React from 'react'
import Header from './Header'
import Footer from './Footer'

export default function Layout(props) {
  const {
    className,
    containerClassName,
    header,
    footer,
    children,
  } = props

  return (
    <div
      className={[
        containerClassName,
        'min-h-screen flex flex-col',
      ]}
    >
      {header ? header : <Header />}
      <main
        className={[
          className,
          'flex-1'
        ]}
      >
        {children}
      </main>
      {footer ? footer : <Footer />}
    </div>
  )
}
